import {Box, Button, styled} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import {useSetRecoilState} from "recoil";
import {snackBarState, snackBarToggleState} from "../Recoil/Atom/snackBarState";

const ButtonCroupContainer = styled(Box)(({theme}) => ({
  display: "flex",
  justifyContent: "center",
  padding: "40px 0 80px 0",
  "& .btnCancel": {
    marginRight: "24px",
    color: "#fff",
  },
}));

type ConfirmButtonProps = {
  link: any;
  editLink?: string;
  cancelText: string;
  confirmText: string;
};

const ConfirmButtonGroup = ({link, editLink, cancelText, confirmText}: ConfirmButtonProps) => {
  const navigate = useNavigate();

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  return (
    <ButtonCroupContainer>
      <Button
        className="btnCancel"
        variant="contained"
        color="warning"
        onClick={() => {
          navigate(link);
          setSnackBarToggle(true);
          setSnackBarState("cancel");
        }}
      >
        {cancelText}
      </Button>
      <Button variant="contained" color="success" type="submit">
        {editLink === undefined ? (
          confirmText
        ) : (
          <Link to={editLink} style={{color: "#fff"}}>
            {confirmText}
          </Link>
        )}
      </Button>
    </ButtonCroupContainer>
  );
};

export default ConfirmButtonGroup;
